import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get, pad } from "lodash";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import Select from "react-select";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "./usermanagement.css";
import Input from "../../components/Input";
import Overlay from "../../components/Overlay";
import { Modal } from "../../components/Modal";
import { bottom } from "@popperjs/core";
import { extractDate, extractOnlyDate, maskToken, uploadImage, subadminAccessChange } from "../../utils/functions";

// Mui & material UI
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import SearchBar from "material-ui-search-bar";
import FormGroup from '@mui/material/FormGroup';
import Typography from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Popover, Box } from "@mui/material";
import PaginationItem from '@mui/material/PaginationItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  Paper,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination
} from "@material-ui/core";

import * as XLSX from 'sheetjs-style';
import { saveAs } from "file-saver";

// icons 
// import { RxCross2 } from "react-icons/rx";
import { TiInfoLarge } from "react-icons/ti";
import { AiOutlineMail } from "react-icons/ai";
import { IoCallOutline } from "react-icons/io5";
import { GoCalendar } from "react-icons/go";
import { LuContact } from "react-icons/lu";
import { AiOutlineDownload } from "react-icons/ai";
import { SlClose } from "react-icons/sl";
import { GrApple } from "react-icons/gr";
import { RiDeleteBin6Line } from "react-icons/ri";
import { PiAndroidLogoFill } from "react-icons/pi";
import { TiInfoOutline, TiTick } from "react-icons/ti";
import { RxCross2, RxCrossCircled } from "react-icons/rx";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import { BsDot, BsEyeFill, BsPlus, BsThreeDotsVertical } from "react-icons/bs";
import { MdBlock, MdClose, MdEmail, MdLocalPhone, MdPhone } from "react-icons/md";
import { IoArchive, IoArrowBackCircleOutline, IoArrowForwardCircleOutline } from "react-icons/io5";
import { FaFilter, FaGlobe, FaArrowLeft, FaPhone, FaUser, FaUserAlt, FaUserCheck } from "react-icons/fa";
import { useSearchParams } from 'react-router-dom';

import Verified from "../../assets/images/verification.png";
import Agni from "../../assets/images/agni.png";
import android from "../../assets/images/Androide.png";
import vector from "../../assets/images/Vector.png";


// Elements
import { InputDivide } from "../Authentican/Profile/ProfileElements";
import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  SearchFilterContainer,
  DashHeading,
  Button,
  DeleteButton,
  ProfileDetailForm,
  SelectedColumnContainer,
  Filter,
  DpBox,
  Fields,
  Resetbtn,
  Applybtn,
} from "./UserManagementElements";
import YearInput from '../../components/YearInput';
import BlockToggle from "../../components/Toglebutton/Togle";
import { fontGrid } from "@mui/material/styles/cssUtils";
import NoResults from "../../components/NoResult";
import Loading from "../../components/Loading";

const useStyles = makeStyles((theme) => ({
  table: {
    borderCollapse: 'separate',
    borderSpacing: '0 6px', // adds vertical spacing between rows
  },
  tableMainContainer: {
    maxHeight: "65vh",
    overflowX: "auto",
    overflowY: "auto",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
  },
  tableHeadingRow: {
    position: "sticky", // Make header sticky
    top: 0, // Stick to the top
    zIndex: 1, // Ensure it appears above other rows
    background: "#FFFFFF", // Header background color
    border: "1px solid rgba(17, 153, 38, 0.20)",

  },
  tableBodyRow: {
    background: "#FFFFFF",


    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  tableHeadingCell: {
    // padding: "0.5rem 1rem !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#1C2D28",
    fontWeight: "500",
    // border: "1px solid #D9E3D9",
    whiteSpace: "nowrap",
    background: "#FFFFFF",
    border: "none"
  },
  textMiddle: {
    padding: "0.3rem 1rem !important",
    verticalAlign: "middle !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#484848",
    fontFamily: "Roboto",
    fontWeight: "400",
    background: "#FFFFFF",
    border: "none"

  },
  tablePaginationStyle: {
    borderTop: "1px solid #0000001a",
    borderRadius: "0rem 0rem 0.4rem 0.4rem",
    overflowY: "hidden",
  },
  paginationContainer: {
    marginTop: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));




const UserManagement = ({ setUsers, userData }) => {
  const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));


  const userManagementPermissions = adminData?.adminpermissions?.modules?.find(
    (module) => module.moduleName === "User Management"
  )?.permissions || {};

  const canView = !!userManagementPermissions.view;
  const canAdd = !!userManagementPermissions.add;
  const canEdit = !!userManagementPermissions.edit;
  const canDelete = !!userManagementPermissions.delete;
  const canBlockUnblock = !!userManagementPermissions.blockUnblock;
  const canDownload = !!userManagementPermissions.download;


  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  const [excelData, setExcelData] = useState([]);

  const [deleteModal, setDeleteModal] = useState(false);
  const [userDetails, setUserDetails] = useState()
  console.log("userDetails", userDetails)


  const [searchParams, setSearchParams] = useSearchParams();

  const [sorting, setSorting] = useState({
    sortByUserName: null,
    sortByJoiningDate: null,
    sortByUserId: null,
    defaultSorting: -1,
  });
  const [rotations, setRotations] = useState({
    sortByUserName: 0,
    sortByJoiningDate: 0,
    sortByUserId: 0,
  });



  const queryTab = new URLSearchParams(location.search).get("Tab");
  const dashboardTab = location?.state?.dashboardTab;

  // Set initial status based on dashboardTab
  const initialStatus = queryTab === "Guest" && dashboardTab === "4" ? 4 : 2;

  const [filterStatus, setFilterStatus] = useState(initialStatus);


  // const [filterStatus, setFilterStatus] = useState(2
  //   // localStorage.getItem("filterTypeUser") || 2
  // ); // Default to active users

  const handleServiceTypeChange = (type) => {
    setFilterStatus(type);
    setIsLoading(true);
    localStorage.setItem("filterTypeUser", type);
    if (type === 4) { setSearchParams({ Tab: 'Guest' }); }
    else if (type === 2) { setSearchParams(''); }
  };


  useEffect(() => {
    const tabFromQuery = new URLSearchParams(location.search).get("Tab");
    const dashboardTab = location?.state?.dashboardTab;

    if (tabFromQuery === "Guest" && dashboardTab === "4") {
      handleServiceTypeChange(4);
    }
  }, [location]);


  // For Pagination
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalDocs, setTotalDocs] = useState(0);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(1); // Reset to the first page when rows per page change
  };

  const handleChangePage = (event, newPage) => {
    // handleCancel();
    setPage(newPage);


    // localStorage.setItem("currentPage", newPage); // Store the page number

  };


  // For Select checkbox
  const [selectedRows, setSelectedRows] = useState([]);
  useEffect(() => {
    if (tableData.length === 0) {
      setSelectedRows([]);
    }
  }, [tableData]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedRows(tableData.map((item) => item._id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id) => {
    const newSelectedRows = selectedRows.includes(id)
      ? selectedRows.filter((rowId) => rowId !== id)
      : [...selectedRows, id];
    setSelectedRows(newSelectedRows);
  };

  const handleClearSelection = () => {
    setSelectedRows([]);
  };

  // Open Popover
  const [anchorEl, setAnchorEl] = useState(null);

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget); // Open the filter popover
  };


  const open = Boolean(anchorEl);
  const id = open ? "filter-popover" : undefined;

  const [anchorElDevice, setAnchorElDevice] = useState(null);

  const handleDeviceClick = (event) => {
    setAnchorElDevice(event.currentTarget); // Open the filter popover
  };

  const openDevice = Boolean(anchorElDevice);
  const idDevice = openDevice ? "filter-popover" : undefined;


  const [zipCode, setZipCode] = useState("");
  const [gigsCompleted, setGigsCompleted] = useState();
  // Filter date
  const [startDate, setStartDate] = useState(null);
  const [filterDates, setFilterDates] = useState({ startDate: "" });
  const [anchorElFilter, setAnchorElFilter] = useState(null);


  const advanceFilterClick = (event) => {
    setAnchorElFilter(event.currentTarget); // Open the filter popover
  };

  const handleApply = () => {

    if (!startDate && !zipCode && !gigsCompleted) {
      toast.warning("Please fill at least one filter field to search.", {
        position: "top-right",
      });
      return;
    }
    const adjustDateTime = (date, isEndOfDay = false) => {
      if (!date) return "";

      const adjustedDate = new Date(date);

      if (isEndOfDay) {
        adjustedDate.setHours(23, 59, 59, 999); // End of the day
      } else {
        adjustedDate.setHours(0, 0, 0, 0); // Start of the day
      }

      return `${adjustedDate.getFullYear()}-${String(adjustedDate.getMonth() + 1).padStart(2, "0")}-${String(adjustedDate.getDate()).padStart(2, "0")}T${String(adjustedDate.getHours()).padStart(2, "0")}:${String(adjustedDate.getMinutes()).padStart(2, "0")}:${String(adjustedDate.getSeconds()).padStart(2, "0")}.000Z`;
    };


    const normalizedStartDate = adjustDateTime(startDate, false); // Start of the day

    setFilterDates({
      startDate: normalizedStartDate,
    });

    setAnchorElFilter(null); // Close the filter popover
    setPage(1)
  };

  const handleCancel = () => {
    setStartDate(null);
    setZipCode("");
    setGigsCompleted("");
    setFilterDates({ startDate: "" });
    setPage(1);
  };

  const handleClose = () => {
    setAnchorEl(null); // Only close the popover without resetting
  };

  const handleCloseDevice = () => {
    setAnchorElDevice(null); // Only close the popover without resetting
  };

  const handleClosefilter = () => {
    setAnchorElFilter(null); // Only close the popover without resetting
  };

  const handleStartDateChange = (date) => {
    if (date && new Date(date) > new Date()) {
      toast.warning(`From date cannot be greater than the To date`, {
        position: "top-right",
      });
      return; // Prevent updating the start date
    }
    setStartDate(date || null); // Update the start date if valid
  };

  const openFilter = Boolean(anchorElFilter);
  const ids = openFilter ? "filter-popover" : undefined;






  // For Search functionality
  const [searchTerm, setSearchTerm] = useState("");

  function myDeb(call, d = 1000) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        call(...args);
      }, d);
    };
  }

  const SearchAccountManagement = myDeb((search) => {
    setSelectedRows([]);
    setSearchTerm(search);
    setPage(1); // Reset to the first page on search
  });

  const cancelSearch = () => {
    setSearchTerm("");
    setPage(1); // Reset to the first page when search is canceled
  };





  useEffect(() => {



    // Fetch the user list data for the current page
    getUserManagementData(page)
    getExcelData()
      .then((res) => res.json())
      .then((data) => setExcelData(data))
      .catch((error) => console.error("Error fetching data:", error));

  }, [page, rowsPerPage, searchTerm, filterStatus, filterDates, location]);


  const toggleSort = (field) => {
    setSorting((prev) => {
      let newSorting = {
        sortByUserName: null,
        sortByJoiningDate: null,
        sortByUserId: null,
        defaultSorting: null,
      };

      let newValue = prev[field] === 1 ? -1 : 1;
      newSorting[field] = newValue;

      // 👉 Rotate image toggle
      setRotations((prev) => ({
        ...prev,
        [field]: prev[field] === 0 ? 180 : 0, // toggle between 0 and 180
      }));

      // API call
      getUserManagementData(1, newSorting);

      return newSorting;
    });
  };



  const getUserManagementData = async (currentPage, sortingParam = sorting) => {
    setIsLoading(true);
    setTotalDocs(0);

    try {
      const { data } = await axios.post(`/private/getAllUserList?page=${currentPage}&limit=${rowsPerPage}&search=${searchTerm}`, {
        startDate: filterDates.startDate || undefined,
        zipCode: zipCode ? [zipCode] : [],
        gigCompletedCount: Number(gigsCompleted),
        status: String(filterStatus),
        ...sortingParam,
      });

      setTableData(data?.data?.docs);
      setTotalDocs(data?.data?.totalDocs)
      console.log("objecttableData", data)

    } catch (error) {
      if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
        navigate("/");
      } else if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else {
        console.log("error", error?.response)
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Block unblock functionality
  const blockUnblock = async (id) => {
    try {
      const response = await axios.get(`/private/userBlock/${id}`);

      toast.success(response.data.message, {
        position: "top-right",
      });
      getUserManagementData(page);
    } catch (error) {


      if (error.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        toast.error(error.response.data?.message, {
          position: "top-right",
        });
        navigate("/");
      } else {
        toast.error("Something went wrong", {
          position: "top-right",
        });
      }
    }
  };



  const handleDownload = () => {
    // Format keys: convert camelCase to space-separated & capitalize, handle _id
    const formatKey = (key) => {
      if (key === '_id') return 'User Id';
      return key
        .replace(/([a-z])([A-Z])/g, '$1 $2')  // Add space before capital letters
        .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
    };

    // Function to format date if key is createdAt
    const formatValue = (key, value) => {
      if ((key === "createdAt" || key === "lastActive" || key === "dateOfBirth") && value) {
        return new Date(value).toLocaleString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true
        });
      }
      return value;
    };


    // Format data with formatted headers
    const formattedData = excelData.map(item => {
      const newItem = {};
      Object.entries(item).forEach(([key, value]) => {
        newItem[formatKey(key)] = formatValue(key, value);
      });
      return newItem;
    });


    // Create worksheet from formatted data
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    // Auto-calculate column widths
    const keys = Object.keys(formattedData[0] || {});
    const colWidths = keys.map(key => {
      const maxLength = Math.max(
        key.length,
        ...formattedData.map(row => (row[key] ? row[key].toString().length : 0))
      );
      return { wch: maxLength + 2 };
    });
    worksheet["!cols"] = colWidths;

    // Bold header row (row 0)
    keys.forEach((key, index) => {
      const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].s = {
          font: { bold: true }
        };
      }
    });

    // Create workbook and append sheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Write and download
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "table_data.xlsx");
  };




  // getExcelData
  const getExcelData = async () => {

    try {
      const { data } = await axios.post(`/private/getUserExcelData`, {
        status: "2"
        // status: String(filterStatus),

      });
      setExcelData(data?.data);


    } catch (error) {
      if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("error", error?.response)
      }
    } finally {
      setIsLoading(false);
    }
  };


  // Delete user functionality - handles both single and multiple deletions
  const DeleteUser = async (id = null) => {
    const idsToDelete = id ? [id] : selectedRows;

    if (idsToDelete.length === 0) {
      toast.error('No users selected for deletion', {
        position: "top-right",
      });
      return;
    }

    setIsLoading(true);

    try {
      // Using axios.request to support sending data in the body with DELETE method
      const { data } = await axios({
        method: 'delete',
        url: `/private/deleteUsers`,
        data: {
          ids: idsToDelete,
        },
      });



      setDeleteModal(false);
      toast.success(data?.message);
      handleClearSelection();
      setSelectedRows([]);  // Clear selected rows after deletion
      getUserManagementData(page);  // Refresh table after deletion
    } catch (error) {
      if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        toast.error('Something went wrong', {
          position: "top-right",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };



  return (
    <>
      <DashboardContainer>
        <DashboardWrapper>
          <ProfileDetailForm>
            <DashboardHeading style={{ display: "flex", justifyContent: "space-between" }}>
              <div>User Management</div>
              <div>
                {filterStatus == "2" && !(!canDownload && adminData?.userType === "subAdmin") && (
                  <Button
                    type="button"
                    style={{
                      backgroundColor: "#5088FB",
                      color: "#FFFFFF",
                      border: "1px solid #5088FB",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      padding: "4px 8px",
                    }}
                    onClick={handleDownload}
                  >
                    Export as xlsx <AiOutlineDownload style={{ fontSize: "1.2rem" }} />
                  </Button>
                )}
              </div>
            </DashboardHeading>

            <SearchFilterContainer style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                <Button
                  type="button"
                  style={{
                    backgroundColor:
                      filterStatus == 2 ? "#5088FB" : "",
                    color: filterStatus == 2 ? "#ffffff" : "#201D23",
                    fontSize: "14px",
                    fontFamily: "Inter",
                    fontWeight: filterStatus == 2 ? "600" : "400"


                  }}
                  onClick={() => {
                    handleCancel();
                    setSelectedRows([]);
                    handleServiceTypeChange(2);
                    setPage(1);
                  }}
                  disabled={filterStatus == 2}
                >
                  Registered User {filterStatus == 2 ? `(${isLoading ? "" : totalDocs})` : ""}
                </Button>
                <Button
                  type="button"
                  style={{
                    backgroundColor:
                      filterStatus == 4 ? "#5088FB" : "",
                    color: filterStatus == 4 ? "#ffffff" : "#201D23",
                    fontSize: "14px",
                    fontFamily: "Inter",
                    fontWeight: filterStatus == 4 ? "600" : "400",

                  }}
                  onClick={() => {
                    handleCancel();
                    setSelectedRows([]);
                    handleServiceTypeChange(4);
                    setPage(1);
                  }}
                  disabled={filterStatus == 4}
                >
                  Guest User {filterStatus == 4 ? `(${isLoading ? "" : totalDocs})` : ""}
                </Button>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>

                {filterStatus == "2" && (
                  <>
                    <SearchBar
                      style={{
                        minWidth: "25rem",
                        height: "40px",
                        borderRadius: "20px",
                        backgroundColor: "#F8F9FB",
                        color: "#212121",
                        fontStyle: "Italic",
                        fontWeight: 300,
                        fontSize: "15px",
                        fontFamily: "Roboto",

                      }}
                      className={"heightfix"}
                      onChange={(e) => {
                        SearchAccountManagement(e);
                      }}
                      onCancelSearch={cancelSearch}
                      placeholder="Search by User ID, User Name, User Email ID"
                      inputProps={{ maxLength: 30 }}
                    />
                    <div
                      type="button"
                      style={{ color: "#5088FB", fontSize: "16px", fontFamily: "Roboto", fontWeight: "500" }}
                      onClick={advanceFilterClick}
                    >
                      <BsPlus
                        style={{
                          color: "#5088FB",
                          marginRight: "6px",
                          fontSize: "1.5rem",
                        }}
                      />
                      Advance Filter
                    </div>
                  </>
                )}
              </div>


            </SearchFilterContainer>


            {selectedRows.length > 0 && (
              <SelectedColumnContainer>
                <DeleteButton
                  type="button"
                  className="buttonWidthResponsive"
                  onClick={() => {
                    setDeleteModal(true);
                  }}
                >
                  Delete
                </DeleteButton>
                <div className="column-selected">{selectedRows.length} Selected</div>
                <div
                  className="container-clear-selection"
                  onClick={handleClearSelection}
                >
                  <RxCrossCircled />
                  <span className="column-selected">Clear Response</span>
                </div>
              </SelectedColumnContainer>
            )}

            <TableContainer
              className={classes.tableMainContainer}
            >
              <Table className={classes.table}>
                <TableHead>
                  <TableRow className={classes.tableHeadingRow} >
                    {!(!canDelete && adminData?.userType === "subAdmin") && (
                      <TableCell className={classes.tableHeadingCell}>
                        <div style={{ marginLeft: "0.8rem", display: "flex", gap: "1rem" }}>
                          <Checkbox
                            style={{ padding: "2px" }}
                            indeterminate={selectedRows.length > 0 && selectedRows.length < tableData.length}
                            checked={selectedRows.length > 0 && selectedRows.length === tableData.length}
                            onChange={handleSelectAll}
                            color="primary"
                          // disabled={!canDelete && adminData?.userType == "subAdmin"} // Disable if canDelete is false
                          />
                          <div> S.No</div>
                        </div>
                      </TableCell>
                    )}
                    {/* <TableCell className={classes.tableHeadingCell}>
                      S.No
                    </TableCell> */}
                    {filterStatus == "2" && (
                      <>
                        <TableCell className={classes.tableHeadingCell}>
                          <div style={{ textAlign: "left", marginLeft: "1rem" }}>
                            User Name{" "}
                            <img
                              src={vector}
                              style={{
                                cursor: "pointer",
                                transition: "transform 0.3s ease",
                                transform: `rotate(${rotations.sortByUserName}deg)`,
                              }}
                              onClick={() => toggleSort("sortByUserName")}
                            />
                          </div>
                        </TableCell>
                        {!(!canBlockUnblock && adminData?.userType === "subAdmin") && (
                          <TableCell className={classes.tableHeadingCell}>
                            Block/Unblock
                          </TableCell>
                        )}
                      </>
                    )}
                    <TableCell className={classes.tableHeadingCell}>
                      {/* Joining Date <img src={vector} /> */}
                      Joining Date{" "}
                      <img
                        src={vector}
                        style={{
                          cursor: "pointer",
                          transition: "transform 0.3s ease",
                          transform: `rotate(${rotations.sortByJoiningDate}deg)`,
                        }}
                        onClick={() => toggleSort("sortByJoiningDate")}
                      />
                    </TableCell>
                    {filterStatus == "2" && (
                      <TableCell className={classes.tableHeadingCell}>
                        <div style={{ marginLeft: "3rem", textAlign: "left" }}>
                          Legal Name
                        </div>
                      </TableCell>
                    )}
                    {filterStatus == "2" && (
                      <TableCell className={classes.tableHeadingCell}>
                        User ID{" "}
                        <img
                          src={vector}
                          style={{
                            cursor: "pointer",
                            transition: "transform 0.3s ease",
                            transform: `rotate(${rotations.sortByUserId}deg)`,
                          }}
                          onClick={() => toggleSort("sortByUserId")}
                        />
                      </TableCell>
                    )}
                    {filterStatus == "4" && (
                      <TableCell className={classes.tableHeadingCell}>
                        User ID
                      </TableCell>
                    )}

                    <TableCell className={classes.tableHeadingCell}>
                      Last Active
                    </TableCell>
                    {filterStatus == "2" && (
                      <>
                        <TableCell className={classes.tableHeadingCell}>
                          Gigs Completed
                        </TableCell>
                        <TableCell className={classes.tableHeadingCell}>
                          SSN Number
                        </TableCell>
                        <TableCell className={classes.tableHeadingCell}>
                          Zip Code
                        </TableCell>
                      </>
                    )}
                    <TableCell className={classes.tableHeadingCell}>
                      <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                        Device Type
                      </div>
                    </TableCell>
                  </TableRow>
                </TableHead>
                {isLoading && tableData && tableData.length > 0 ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={13} align="center" style={{ border: "none" }}>
                        <Loading />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : tableData && tableData.length > 0 ? (
                  <>
                    <TableBody>
                      {tableData.map((user, index) => (
                        <TableRow className={classes.tableBodyRow} key={user._id}>
                          {!(!canDelete && adminData?.userType === "subAdmin") && (
                            <TableCell className={classes.textMiddle}>
                              <div style={{ display: "flex", gap: "1rem" }}>
                                <Checkbox
                                  style={{ padding: "2px" }}
                                  checked={selectedRows.includes(user._id)}
                                  onChange={() => handleSelectRow(user._id)}
                                  color="primary"
                                // disabled={!canDelete && adminData?.userType == "subAdmin"} // Disable if canDelete is false
                                />
                                <div>{index + 1 + rowsPerPage * (page - 1)}</div>
                              </div>
                            </TableCell>
                          )}

                          {filterStatus == "2" && (
                            <>
                              <TableCell className={classes.textMiddle}>
                                <div style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  color: "#375DFB",
                                  textAlign: "left",

                                }}
                                  onClick={() => navigate(`/userDetails/${user._id}`,
                                    { state: { from: "userManagement", tabStatus: filterStatus, page, rowsPerPage } }

                                  )}
                                >
                                  {user?.userName || "N/A"}
                                </div>
                              </TableCell>
                              {!(!canBlockUnblock && adminData?.userType === "subAdmin") && (
                                <TableCell className={classes.textMiddle}>
                                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <BlockToggle
                                      checked={user.isBlocked == "2"}
                                      onChange={() => blockUnblock(user._id, user.isBlocked == "1")}
                                    />
                                  </div>
                                </TableCell>
                              )}
                            </>
                          )}
                          <TableCell className={classes.textMiddle}>
                            <div style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}>
                              {extractDate(get(user, "createdAt", "---"))}
                            </div>
                          </TableCell>
                          {filterStatus == "2" && (
                            <TableCell className={classes.textMiddle}>
                              <div style={{
                                display: "flex",
                                gap: "5px",
                                marginLeft: "2rem"

                              }}>{user?.fullName || "N/A"}
                                <div>
                                  <TiInfoLarge
                                    style={{
                                      backgroundColor: "#5088FB",
                                      color: "#FFFFFF",
                                      fontSize: "0.8rem",
                                      cursor: "pointer",
                                      borderRadius: "1rem",

                                    }}
                                    onClick={(e) => {
                                      setUserDetails(user);
                                      handleFilterClick(e)
                                    }}
                                  />
                                </div>
                              </div>
                            </TableCell>
                          )}
                          <TableCell className={classes.textMiddle}>
                            <div>{get(user, "userId", "---")}</div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div>
                              {filterStatus == "2" ? (
                                extractDate(get(user, "lastActive", "---"))
                              ) : (
                                extractDate(get(user, "updatedAt", "---"))
                              )}
                            </div>
                          </TableCell>
                          {filterStatus == "2" && (
                            <>
                              <TableCell className={classes.textMiddle}>
                                <div>{get(user, "completedGigInviteCount", "---")}</div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div>{get(user, "ssnlast4")
                                  ? `XXXXXX${get(user, "ssnlast4").slice(-4)}`
                                  : "N/A"}</div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div>{get(user, "zipCode", "N/A")}</div>
                              </TableCell>
                            </>
                          )}
                          <TableCell className={classes.textMiddle}>
                            <div style={{ display: "flex", gap: "0.5rem", marginLeft: "2rem" }}>
                              <div>
                                {/* {get(user, "sessionData[0].deviceType") === "android" ? (
                                  <img src={android} style={{ width: "24px", height: "24px" }} />
                                ) : get(user, "sessionData[0].deviceType")?.toLowerCase() === "ios" ? (
                                  <GrApple style={{ fontSize: "20px", color: "#424245" }} />
                                ) : (
                                  "Logged Out"
                                )} */}
                                {get(user, "sessionData.logOut") === true ? (
                                  <span>Logged Out</span>
                                ) : get(user, "sessionData.deviceType") === "android" ? (
                                  <img src={android} style={{ width: "24px", height: "24px" }} />
                                ) : get(user, "sessionData.deviceType")?.toLowerCase() === "ios" ? (
                                  <GrApple style={{ fontSize: "20px", color: "#424245" }} />
                                ) : (
                                  <span>Logged Out</span>
                                )}
                              </div>
                              <div>
                                <TiInfoLarge
                                  style={{
                                    backgroundColor: "#5088FB",
                                    color: "#FFFFFF",
                                    fontSize: "0.8rem",
                                    cursor: "pointer",
                                    borderRadius: "1rem",

                                  }}
                                  onClick={(e) => {
                                    setUserDetails(user);
                                    handleDeviceClick(e)
                                  }}
                                />
                              </div>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </>
                ) : (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={13} align="center" style={{ padding: "2rem", border: "none" }}>
                          <DashHeading style={{ textAlign: "center", padding: "2rem" }}><NoResults /></DashHeading>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                )}
              </Table>
            </TableContainer>
            {(tableData && tableData.length > 0) && (
              <>
                <Stack spacing={2} className={classes.paginationContainer}>
                  <Pagination
                    count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                    page={page}
                    onChange={(event, value) => handleChangePage(event, value)} // Update page
                    renderItem={(item) => (
                      <PaginationItem
                        slots={{ previous: HiMiniArrowLeft, next: HiMiniArrowRight }}
                        {...item}
                      />
                    )}
                  />
                </Stack>
              </>
            )}
          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer >

      {/* Modal for Delete User  */}
      < Modal
        maxWidth="lg"
        width="360px"
        RoundedCorners={true}
        isOpen={deleteModal}
        onClose={() => {
          setDeleteModal(false);
        }}
        backgroundModal={false}
        backgroundModalContent={false}
        title={
          <div div >
            <div className="d-flex align-items-center justify-content-end">
              <RxCross2
                style={{
                  cursor: "pointer",
                }}
                onClick={() => { setDeleteModal(false); }}
              />
            </div>
            <p className="profile-section-text">Delete Users</p>
            <div className="logout-header" style={{ paddingTop: "0px" }}>Are you sure you want to delete users? Deleting them will permanently remove all their data.</div>
          </div >
        }
        content={
          <>
            <div className="logout-button-group">
              <div
                className="cancel-button"
                onClick={() => {
                  setDeleteModal(false);
                }}
              >
                Cancel
              </div>
              <div className="logout-button" style={{ background: "#5088FB" }} onClick={() => DeleteUser(null)}>
                Confirm
              </div>
            </div>
          </>
        }
      />

      <Popover Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, width: "250px" }}>
          <div>
            <p className="user_info">User Info</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
              <div className="userdata"><LuContact className="user_icon" /><span>{userDetails?.userId}</span></div>
              <div className="userdata"><AiOutlineMail className="user_icon" /><span>{userDetails?.email} <img src={Verified} /> </span> </div>
              <div className="userdata"><IoCallOutline className="user_icon" /><span>{userDetails?.countryCode} {userDetails?.phoneNumber} <img src={Verified} /> </span></div>
              <div className="userdata"><GoCalendar className="user_icon" /><span>{extractOnlyDate(userDetails?.dateOfBirth)}</span></div>
              <div className="userdata"><img src={Agni} style={{ width: "20px", height: "20px" }} /><span>{userDetails?.userStreakDetails?.streakCount ?? "0"}</span></div>
            </div>
          </div>
        </Box>
      </Popover >

      {/* Filter Popover */}
      <Popover Popover
        id={ids}
        open={openFilter}
        anchorEl={anchorElFilter}
        onClose={handleClosefilter}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, width: "300px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "0.8rem" }}>
            <div className="text-filter">Advance Filter</div>
            <div className="clear-filter" onClick={handleCancel}>Reset all</div>
          </div>

          <div className="mb-3">
            <label className="headname">Joining Date</label>
            <YearInput
              style={{
                background: "#FFFFFF",
                border: "1px solid #D0D5DD"
              }}
              selected={startDate}
              onChange={handleStartDateChange}
              placeholderText="Select Date"
              maxDate={new Date()}
            />
          </div>

          <div className="mb-3">
            <label className="headname">Zip Code</label>
            <Input
              type="text"
              className="form-control"
              style={{
                background: "#FFFFFF",
                border: "1px solid #D0D5DD",
                padding: "5px",
                borderRadius: "4px"
              }}
              value={zipCode}
              onChange={(e) => setZipCode(e.target.value)}
              placeholder="Enter Zip Code"
            />
          </div>

          <div className="mb-3">
            <label className="headname">Gigs Completed</label>
            <Input
              type="text"
              className="form-control"
              style={{
                background: "#FFFFFF",
                border: "1px solid #D0D5DD",
                padding: "5px",
                borderRadius: "4px"
              }}
              value={gigsCompleted}
              onChange={(e) => setGigsCompleted(e.target.value)}
              placeholder="Enter Number"
            />
          </div>

          <Box sx={{ display: "flex", justifyContent: "center", mt: 3, gap: 2 }}>
            <Button onClick={handleClosefilter} color="secondary">
              Cancel
            </Button>
            <Button onClick={handleApply} style={{ background: "#5088FB", color: "#ffffff", fontFamily: "Roboto", fontWeight: "700" }}>
              Apply
            </Button>
          </Box>
        </Box>
      </Popover >

      {/* Devaice */}
      <Popover Popover
        id={idDevice}
        open={openDevice}
        anchorEl={anchorElDevice}
        onClose={handleCloseDevice}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >



        <Box sx={{ p: 2, width: "320px", }}>
          <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="user_info">Device Details</div>
              <div className="user_info">
                <RxCross2
                  style={{
                    fontSize: "1.3rem",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setAnchorElDevice(null);
                  }}
                />
              </div>
            </div>

            <div style={{ marginTop: "0.5rem" }}>

              {/* Scrollable tbody container */}
              <div
                style={{
                  maxHeight: "10.2rem",
                  overflowY: "scroll",
                  scrollbarWidth: "none",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                }}
              >
                <table className="invoice-table">
                  <thead>
                    <tr>
                      <th>Device Name</th>
                      <th >Last Active</th>
                      <th>Device Type</th>
                    </tr>
                  </thead>
                  {filterStatus == "2" && (
                    <tbody>
                      {userDetails?.userLoginHistory && userDetails.userLoginHistory.length > 0 ? (


                        userDetails.userLoginHistory.map((user, index) => (
                          <tr key={index}>
                            <td className="">{user?.deviceName ?? "N/A"}</td>
                            <td >
                              {(() => {
                                const dateTime = extractDate(user?.createdAt ?? "N/A");
                                if (dateTime === "N/A") return "N/A";
                                const [date, time] = dateTime.split(", ");
                                return (
                                  <>
                                    <div>{date}</div>
                                    <div>{time}</div>
                                  </>
                                );
                              })()}
                            </td>
                            <td>
                              {get(user, "deviceType") === "android" ? (
                                <img
                                  src={android}
                                  style={{ width: "24px", height: "24px" }}
                                />
                              ) : get(user, "deviceType")?.toLowerCase() === "ios" ? (
                                <GrApple
                                  style={{ fontSize: "20px", color: "#424245" }}
                                />
                              ) : (
                                "N/A"
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="3"
                            style={{ textAlign: "center", padding: "20px" }}
                          >
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}

                  {filterStatus == "4" && (
                    <tbody>
                      {userDetails ? (


                        // userDetails.map((user, index) => (
                          <tr>
                            <td className="">{userDetails?.deviceName ?? "N/A"}</td>
                            <td >
                              {(() => {
                                const dateTime = extractDate(userDetails?.updatedAt ?? "N/A");
                                if (dateTime === "N/A") return "N/A";
                                const [date, time] = dateTime.split(", ");
                                return (
                                  <>
                                    <div>{date}</div>
                                    <div>{time}</div>
                                  </>
                                );
                              })()}
                            </td>
                            <td>
                              {get(userDetails, "deviceType") === "android" ? (
                                <img
                                  src={android}
                                  style={{ width: "24px", height: "24px" }}
                                />
                              ) : get(userDetails, "deviceType")?.toLowerCase() === "ios" ? (
                                <GrApple
                                  style={{ fontSize: "20px", color: "#424245" }}
                                />
                              ) : (
                                "N/A"
                              )}
                            </td>
                          </tr>
                        // ))
                      ) : (
                        <tr>
                          <td
                            colSpan="3"
                            style={{ textAlign: "center", padding: "20px" }}
                          >
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
        </Box>
      </Popover >



      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserManagement);

